import { TableColumnMeta } from "ds/components/Table/types";
import { SearchQueryOrderDirection } from "types/generated";

export const GROUP_IDP_ROW_TEST_ID = "group-idp-row";

export const FILTERS_ORDER_SETTINGS_KEY = "idpGroupMappingFiltersOrder";

export enum IDP_GROUP_COLUMN_ID {
  GROUP_ID = "GROUP_ID",
  DESCRIPTION = "DESCRIPTION",
  SPACES = "SPACES",
  USERS = "USERS",
  LAST_LOGIN = "LAST_LOGIN",
  LOGIN_METHOD = "LOGIN_METHOD",
  STATUS = "STATUS",
  DROPDOWN = "DROPDOWN",
}

export const ROW_HEADER_ID = IDP_GROUP_COLUMN_ID.GROUP_ID;
const MAX_CELL_WIDTH = 600;

export const IDP_GROUP_COLUMNS_STORAGE_KEY = "idpGroupColumnsConfig";

export enum IdpGroupFilterItemKeys {
  GroupId = "groupId",
  Spaces = "spaces",
  Users = "members",
  IdentityProvider = "identityProvider",
  LastLogin = "lastLogin",
  Status = "status",
}

export const INITIAL_SORT_OPTION = IdpGroupFilterItemKeys.GroupId;
export const INITIAL_SORT_DIRECTION = SearchQueryOrderDirection.Asc;

export const SORT_CONFIG: Partial<Record<IDP_GROUP_COLUMN_ID, IdpGroupFilterItemKeys>> = {
  [IDP_GROUP_COLUMN_ID.GROUP_ID]: IdpGroupFilterItemKeys.GroupId,
  [IDP_GROUP_COLUMN_ID.SPACES]: IdpGroupFilterItemKeys.Spaces,
  [IDP_GROUP_COLUMN_ID.USERS]: IdpGroupFilterItemKeys.Users,
  [IDP_GROUP_COLUMN_ID.LOGIN_METHOD]: IdpGroupFilterItemKeys.IdentityProvider,
  [IDP_GROUP_COLUMN_ID.LAST_LOGIN]: IdpGroupFilterItemKeys.LastLogin,
  [IDP_GROUP_COLUMN_ID.STATUS]: IdpGroupFilterItemKeys.Status,
};

export const IDP_GROUP_COLUMN_CONFIG: Record<
  IDP_GROUP_COLUMN_ID,
  TableColumnMeta<IDP_GROUP_COLUMN_ID>
> = {
  [IDP_GROUP_COLUMN_ID.GROUP_ID]: {
    id: IDP_GROUP_COLUMN_ID.GROUP_ID,
    title: "Group ID",
    minWidth: 150,
    defaultWidth: 200,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: false,
    allowsSorting: true,
  },
  [IDP_GROUP_COLUMN_ID.DESCRIPTION]: {
    id: IDP_GROUP_COLUMN_ID.DESCRIPTION,
    title: "Description",
    minWidth: 200,
    defaultWidth: 250,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: false,
    allowsSorting: false,
  },
  [IDP_GROUP_COLUMN_ID.SPACES]: {
    id: IDP_GROUP_COLUMN_ID.SPACES,
    title: "Spaces",
    minWidth: 80,
    defaultWidth: 100,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: false,
    allowsSorting: true,
  },
  [IDP_GROUP_COLUMN_ID.USERS]: {
    id: IDP_GROUP_COLUMN_ID.USERS,
    title: "Users",
    minWidth: 80,
    defaultWidth: 100,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: false,
    allowsSorting: true,
  },
  [IDP_GROUP_COLUMN_ID.LOGIN_METHOD]: {
    id: IDP_GROUP_COLUMN_ID.LOGIN_METHOD,
    title: "Method",
    minWidth: 120,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: false,
    allowsSorting: true,
  },
  [IDP_GROUP_COLUMN_ID.LAST_LOGIN]: {
    id: IDP_GROUP_COLUMN_ID.LAST_LOGIN,
    title: "Last login",
    minWidth: 120,
    defaultWidth: 150,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: false,
    allowsSorting: true,
  },
  [IDP_GROUP_COLUMN_ID.STATUS]: {
    id: IDP_GROUP_COLUMN_ID.STATUS,
    title: "Status",
    minWidth: 100,
    defaultWidth: 120,
    maxWidth: MAX_CELL_WIDTH,
    resizable: true,
    canHide: false,
    allowsSorting: true,
  },
  [IDP_GROUP_COLUMN_ID.DROPDOWN]: {
    id: IDP_GROUP_COLUMN_ID.DROPDOWN,
    title: "Group actions",
    noHeader: true,
    canHide: false,
    maxWidth: 60,
    minWidth: 60,
    defaultWidth: 60,
    resizable: false,
  },
};
